import { render, staticRenderFns } from "./EquipmentItems.vue?vue&type=template&id=f4c8e8b6"
import script from "./EquipmentItems.vue?vue&type=script&lang=js"
export * from "./EquipmentItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports